import React from 'react';
import { BrowserRouter as Router, Link, Route, Routes, useLocation, useParams } from 'react-router-dom';
import { SETTINGS } from 'shared/constants/SETTINGS';
import { USER_PROFILE_ROUTES } from 'shared/constants/USER_PROFILE_ROUTES';
import { LIBRARY_ROUTES } from 'shared/constants/LIBRARY_ROUTES';
import { PRODUCT_MANAGEMENT_ROUTES } from 'shared/constants/PRODUCT_MANAGEMENT_ROUTES';
import { PIPELINE_ROUTES } from 'shared/constants/PIPELINE_ROUTES';

import { Login, Leads, Main, LeadConnect, VoicemailHistory, Calendar, CRMActivity, Error404, UserProfile, Dashboard, Library, ProductManagement, TextCampaign, DialerCampaign, EmailCampaign, Opportunities, Contacts, ContactProfile, Notifications, PasswordChange, ForgottenPassword, OAuthRedirect, NewSettingsPage, SettingsPage, Accounts, MasterAccount, SubAccounts, Account, LinkedContacts, DataManagement, DataCustomizationParentGroup, GroupContacts, Campaigns, Campaign, CampaignTabs, CampaignUserReports, CampaignContactList, CampaignDashboard, CampaignSettings, CampaignHistory, AssignmentRulesContainer, CustomerPipelines, CustomerOrderInvoices, SubscriptionProducts, QuotesAndOrders, InvoicesReport, Billing, InvoicesTab, SequenceReports, TextHistory, UsageStats, CampaignSessionSummary, DialerSessionSummary  } from 'pages';
import RestrictedView from 'shared/RestrictedView';
import ScrollToTop from 'shared/ScrollToTop';
import { RequireAuth } from 'shared/withAuth';
import { Breadcrumb, Header, Segment } from 'semantic-ui-react';

import './App.scss';
import OverviewTab from 'shared/OverviewTab';
import EmailTab from 'shared/EmailTab';
import Timeline from 'shared/TimelineTab';
import Uploads from 'shared/Uploads';
import EventsTab from 'shared/EventsTab';
import ActivitiesTab from 'shared/ActivitiesTab';
import Tasks from 'shared/NewTasksTab';
import Notes from 'shared/Notes';
import DataTab from 'shared/DataTab';
import LeadTab from 'shared/LeadTab';
import OpportunityTab from 'shared/OpportunityTab';
import Pipelines from './pages/Pipeline'
import Groups from 'pages/Groups';
import CampaignsTab from 'shared/CampaignsTab';
import AccountDataTab from 'shared/AccountDataTab';
import { ASSIGNMENT_RULES_ROUTES } from 'shared/constants/ASSIGNMENT_RULES_ROUTES';
import CustomerTab from 'shared/CustomerTab';
import { PHONE_MANAGEMENT_ROUTES } from 'shared/constants/PHONE_MANAGEMENT_ROUTES';
import { BILLING_ROUTES } from 'shared/constants/BILLING_OVERVIEW_ROUTES';
import TermsOfService from 'pages/TermsOfService';
import { useSelector } from 'react-redux';
import { ButtonLink } from 'dyl-components';
import CallHistoryContainer from 'pages/CallHistoryLog';
import MainSidePanelProvider from 'shared/context/MainSidePanelProvider';
import History from 'shared/HistoryTab';
import { USER_PERMISSIONS, RestrictView, multipleRestriction, SETTINGS_PERMISSION_MAP, PRODUCT_PERMISSIONS } from 'dyl-components';
import TextTab from 'shared/TextTab';
import { Error403 } from 'pages';
import { USAGE_STATS_ROUTES } from 'shared/constants/USAGE_STATS_ROUTES';
import TextingComponentProvider from 'shared/context/TextingComponentProvider';

import PipelineReportsPage from 'pages/PipelineReports';
import TextSessionsTable from 'pages/CampaignTabs/CampaignSessionSummary/TextSessionsTable';
class Page extends React.Component {
  render() {
    const PageComponent = this.props.component
    document.title = this.props.title;
    const { component, title, ...otherProps } = this.props;
    return (
      <PageComponent {...otherProps} />
    )
  }
}

const AppQuotesAndOrdersReport = () => {
  return (
    <SettingsPage
      title={'Quotes and Orders'}
      details={{
        favorite_type: "settings",
        setting_report_type: "reports_and_logs.quotes_orders"
      }}
      breadcrumbs={(
        <></>
      )}
    >
      <QuotesAndOrders root='' />
    </SettingsPage>
  )
}

const AppInvoicesReport = () => {
  return (
    <SettingsPage
      title={'Invoices'}
      details={{
        favorite_type: "settings",
        setting_report_type: "reports_and_logs.invoices"
      }}
      breadcrumbs={(
        <></>
      )}
    >
      <InvoicesReport root='' />
    </SettingsPage>
  )
}

const AppCallHistory = () => (
  <SettingsPage
    title={'Call History'}
    details={{
      favorite_type: "settings",
      setting_report_type: "reports_and_logs.call_history"
    }}
    breadcrumbs={(
      <></>
    )}
  >
    <CallHistoryContainer root='' />
  </SettingsPage>
);

const AppSequenceReports = () => (
  <SettingsPage
    title={'Sequence Reports'}
    details={{
      favorite_type: "settings",
      setting_report_type: "reports_and_logs.sequence_report"
    }}
    breadcrumbs={(
      <></>
    )}
  >
    <SequenceReports root='' />
  </SettingsPage>
);

const AppTextHistory = () => (
  <SettingsPage
    title={'Text History'}
    details={{
      favorite_type: "settings",
      setting_report_type: "reports_and_logs.text_history"
    }}
    breadcrumbs={(
      <></>
    )}
  >
    <TextHistory />
  </SettingsPage>
);

const AppPipelineReports = () => (
  <>
    <Header>Pipeline Report</Header>
    <PipelineReportsPage />
  </>
);



const PAGES = [
  { path: 'leads', component: Leads, title: 'Leads', userPermission: USER_PERMISSIONS.LEAD_VIEW },
  { path: 'lead-connect', component: LeadConnect, title: 'Lead Connect' },
  { path: 'groups', component: Groups, title: 'Groups' , userPermission: USER_PERMISSIONS.GROUPS_SUBGROUPS_VIEW},

  { path: 'campaigns', component: Campaigns, title: 'Campaigns', userPermission: USER_PERMISSIONS.CAMPAIGNS_VIEW},
  { path: 'calendar', component: Calendar, title: 'Calendar',  userPermission: USER_PERMISSIONS.CALENDAR_VIEW},
  { path: 'reports/pbx-vm', component: VoicemailHistory, title: 'Voicemails' },
  {
    path: 'text-history', component: () => {
      return <TextingComponentProvider> <AppTextHistory /> </TextingComponentProvider>

    }, title: 'Text History', userPermission: USER_PERMISSIONS.TEXTING_HISTORY_VIEW, productPermission: PRODUCT_PERMISSIONS.TEXT_VIEW
  },
  { path: 'reports/crm_activity', component: CRMActivity, title: 'CRM Activity Report' },
  // TODO: disabled 'til ready
  // { path: '/blast_lists', component: Campaigns, title: 'Campaigns' },
  { path: 'text_campaign', component: TextCampaign, title: 'Text Campaign' },
  { path: 'dialer_campaign', component: DialerCampaign, title: 'Dialer Campaign' },
  { path: 'email_campaign', component: EmailCampaign, title: 'Email Campaign' },
  // TODO: disabled 'til ready
  // { path: '/tools/export', component: Export, title: 'Export' },

  { path: 'opportunities', component: Opportunities, title: 'Opportunities', userPermission: USER_PERMISSIONS.OPPORTUNITY_VIEW },
  { path: 'contacts', component: Contacts, title: 'Contacts', userPermission: USER_PERMISSIONS.CONTACTS_VIEW },
  { path: 'accounts', component: Accounts, title: 'Accounts' },

  { path: 'notifications', component: Notifications, title: 'Notifications' },
  { path: 'read/notifications', component: Notifications, title: 'Read Notifications' },
  { path: 'unread/notifications', component: Notifications, title: 'UnRead Notifications' },
  { path: 'snoozed/notifications', component: Notifications, title: 'Snoozed Notifications' },
  { path: 'archived/notifications', component: Notifications, title: 'Archived Notifications' },
  { path: 'quotes-orders', component: AppQuotesAndOrdersReport, title: 'Quotes and Orders', userPermission: USER_PERMISSIONS.QUOTES_ORDERS_VIEW},
  { path: 'invoices', component: AppInvoicesReport, title: 'Invoices' , userPermission: USER_PERMISSIONS.INVOICE_VIEW},
  { path: 'call-history', component: AppCallHistory, title: 'Call History', userPermission: USER_PERMISSIONS.CALL_HISTORY_VIEW},
  { path: 'sequence-reports', component: AppSequenceReports, title: 'Sequence Reports', userPermission: USER_PERMISSIONS.SEQUENCES_REPORT_VIEW },
  { path: 'pipeline-reports', component: AppPipelineReports, title: 'Pipeline Reports', userPermission: USER_PERMISSIONS.PIPELINES_VIEW }
];



const App = () => {
  const userPermissions = useSelector(state => state.role.userPermissions.permission); 
  const settingsViewPermissionPaths = Object.values(SETTINGS_PERMISSION_MAP || {})?.flat();
  const isSettingsOff = multipleRestriction(settingsViewPermissionPaths, userPermissions);
  const phone = React.useRef({});
  const ws = React.useRef({});
  React.useEffect(() => {
    return () => {
      if(Object.keys(ws.current).length !== 0){
        console.log("|+|Centrifuge Disconnect");
        ws.current.disconnect();
        // eslint-disable-next-line react-hooks/exhaustive-deps
        ws.current.setToken(null)
      }
    }
  }, []);
  const hasOutstandingInvoices = useSelector(state => state.auth.company_status === 'paused');
  const isDyl = useSelector(state => state.auth.dyl_employee);
  return (
    <div className="App">
      <MainSidePanelProvider>
        <Router>
          <ScrollToTop />
          <Routes>
            <Route path='/oauth' element={<OAuthRedirect />} />
            <Route path='/login' element={<Login />} />
            <Route path='/forgot_password' element={<ForgottenPassword />} />
            <Route path='/password_reset' element={<PasswordChange />} />
            <Route path='/healthcheck' element={"ok"} />
            <Route element={<RequireAuth phone={phone} ws={ws} />}>
              <Route path='/terms' element={<TermsOfService />} />
              <Route path='/' element={
                <TextingComponentProvider>
                  <Main phone={phone} />
                </TextingComponentProvider>
              }>
                <Route index element={<Page title={'DYL'} component={Dashboard} />} />
                {PAGES.map(({ path, component, title, userPermission, productPermission }) => (
                  <Route
                    key={path}
                    path={path}
                    element={
                      <RestrictedView productPermission={productPermission} userPermission={userPermission} type="restricted">
                        <Page title={title} component={component} />
                      </RestrictedView>
                    }
                  />
                ))}
                {/* <Route path='import-step-2' element={<Page component={() => <Import activeStep={2} />} title={'Import Step 2'} />} /> possible deprication*/} 

                {/* <Route path='reports' element={<Page component={Reports} title={'Reports'} />} /> possible deprication*/}
                <Route path='master_account/:master_account_id' element={(
                  <RestrictedView userPermission={USER_PERMISSIONS.MASTER_ACCOUNT_VIEW} type="restricted">
                    <Page component={MasterAccount} title='Master Account' />
                  </RestrictedView>
                )}>
                  <Route index path='accounts' element={<SubAccounts accounts={[]} />} />
                  <Route index path='notes' element={<Notes />} />
                </Route>
                <Route path='account/:account_id' element={(
                    // Account Permissions are on Account Page Component, need access to owned/coowned by
                    <Page component={Account} title='Account' />
                )}>
                  <Route index path='' element={<div></div>} />
                  <Route path='data' element={<AccountDataTab />} />
                  <Route path='leads' element={<LeadTab />} />
                  <Route path='opportunities' element={<OpportunityTab />} />
                  <Route path='customer' element={<CustomerTab />}>
                    <Route path='pipelines' element={<CustomerPipelines />} />
                    {isDyl ? (<Route path='orders_invoices' element={<CustomerOrderInvoices />} />) : (
                      <>
                        <Route path='orders' element={<CustomerOrderInvoices />} />
                        <Route path='invoices' element={<InvoicesTab />} />
                      </>
                    )}
                    <Route path='subscription_products' element={<Segment basic><SubscriptionProducts /></Segment>} />
                  </Route>
                  <Route path='contacts' element={<LinkedContacts />} />
                  <Route path='timeline' element={<Timeline root="account" />} />
                  <Route path='texts' element={<TextingComponentProvider><TextTab /></TextingComponentProvider>} />
                  <Route path='emails' element={<EmailTab />} />
                  <Route path='events' element={<EventsTab />} />
                  <Route path='tasks' element={<Tasks />} />
                  <Route path='notes' element={<Notes />} />
                  <Route path='uploads' element={<Uploads />} />
                  <Route path='history' element={<History />} />
                </Route>
                <Route path='contact/:contact_id' element={(
                  <Page title={'Contact Profile'} component={ContactProfile} />
                )}>
                  <Route index path='' exact element={<OverviewTab />} />
                  <Route path='data' element={<DataTab />} />
                  <Route path='lead' element={<LeadTab />} />
                  <Route path='opportunity' element={<OpportunityTab />} />
                  <Route path='campaign' element={<CampaignsTab />} />
                  <Route path='timeline' element={<Timeline root="contact" />} />
                  <Route path='texts' element={<TextingComponentProvider><TextTab /></TextingComponentProvider>} />
                  <Route path='emails' element={<EmailTab />} />
                  <Route path='activities' element={<ActivitiesTab />} />
                  <Route path='events' element={<EventsTab />} />
                  <Route path='tasks' element={<Tasks />} />
                  <Route path='notes' element={<Notes />} />
                  <Route path='uploads' element={<Uploads />} />
                  <Route path='history' element={<History />} />
                </Route>
                <Route path='group/:group_id' element={(
                  <Page title={'Group Contacts'} component={GroupContacts} />
                )}>
                </Route>
                <Route path='campaigns/:id' element={
                  <TextingComponentProvider>
                    <Page title={'Campaign'} component={CampaignTabs} />
                  </TextingComponentProvider>
                }>
                  <Route path='dashboard' element={<CampaignDashboard />} />
                  <Route path='contacts' element={<CampaignContactList />} />
                  <Route path='user-reports' element={<CampaignUserReports />} />
                  <Route path='settings' element={<CampaignSettings />} />
                  <Route path='history' element={<CampaignHistory />} />
                  <Route path='session-summary' element={<CampaignSessionSummary />}>
                    <Route index path='text' element={<TextSessionsTable />} />
                    <Route path='dialer' element={<DialerSessionSummary />} />
                  </Route>
                </Route>
                <Route path='/campaigns/create' element={(
                  <Page title={'Create Campaign'} component={Campaign} />
                )} />
                <Route path='/campaign/:id' element={(
                  <Page title={'Edit Campaign'} component={Campaign} />
                )} />
                <Route path='*' element={<Error404 />} />
              </Route>
              <Route path='/settings' element={<NewSettingsPage />}>
                {SETTINGS.map(({ path: main_path, name, component: Component, pages }, index) => {
                const viewPaths = SETTINGS_PERMISSION_MAP?.[main_path];
                const isRestricted = multipleRestriction(viewPaths, userPermissions)
                return (
                  <React.Fragment>
                    <Route
                      key={main_path}
                      index={index === 0}
                      path={main_path}
                      element={
                        <RestrictView type="restricted" error403={<Error403 />} isRestricted={isRestricted}>
                          <Page component={Component} title={name} />
                        </RestrictView>
                      }
                    >
                      {!pages && PHONE_MANAGEMENT_ROUTES}
                    </Route>
                    {!!pages && pages.map(({ path, page: Component, header, parent, type, favorite_type, subroute, productPermission, userPermission }) => Component && (
                      <Route
                        key={path}
                        path={path}
                        element={(
                          <RestrictedView productPermission={productPermission} userPermission={userPermission} type="restricted">
                            <Page
                              title={header}
                              component={() => {
                                const parent_path = parent?.path || main_path;
                                const parent_name = parent?.name || name;
                                const pathId = parent?.pathId || false;
                                return (
                                  <SettingsComponent
                                    main_path={parent_path}
                                    name={parent_name}
                                    header={header}
                                    path={path}
                                    pathId={pathId}
                                    Component={Component}
                                    type={type}
                                    favorite_type={favorite_type}
                                    subroute={subroute}
                                  />
                                )
                              }}
                            />
                          </RestrictedView>
                        )}
                      />
                    ))}
                  </React.Fragment>
                )})}
                  <Route path='users/:id' element={(
                    <SettingsPage
                      title={'User Profile'}
                      breadcrumbs={(
                        <RestrictedView userPermission={USER_PERMISSIONS.USER_PROFILE_GENERAL_VIEW} type="hidden" userRestrict>
                          <Breadcrumb>
                            <Breadcrumb.Section href={!isSettingsOff ? "/settings/general" : ""}>Settings</Breadcrumb.Section>
                            <Breadcrumb.Divider />
                            <Breadcrumb.Section href={!isSettingsOff ? "/settings/users" : ""}>Users</Breadcrumb.Section>
                            <Breadcrumb.Divider />
                            <Breadcrumb.Section>User</Breadcrumb.Section>
                          </Breadcrumb>
                        </RestrictedView>
                      )}
                    >
                      <RestrictedView userPermission={USER_PERMISSIONS.USER_PROFILE_GENERAL_VIEW} type="restricted" userRestrict>
                        <Page component={UserProfile} title={'User Profile'} />
                      </RestrictedView>
                    </SettingsPage>
                  )}>
                    {USER_PROFILE_ROUTES}
                  </Route>
                  <Route path='data-customization' element={(
                    <SettingsPage
                      title={'Data Customization'}
                      details={{
                        favorite_type: "settings",
                        setting_report_type: "crm_customization.data_customization"
                      }}
                      breadcrumbs={(
                        <Breadcrumb>
                          <Breadcrumb.Section as={Link} to="/settings/general">Settings</Breadcrumb.Section>
                          <Breadcrumb.Divider />
                          <Breadcrumb.Section as={Link} to={`/settings/crm-customizations`}>CRM Customizations</Breadcrumb.Section>
                          <Breadcrumb.Divider />
                          <Breadcrumb.Section>Data Customization</Breadcrumb.Section>
                        </Breadcrumb>
                      )}
                    >
                      <Page component={DataManagement} title={'Data Customization'} />
                    </SettingsPage>
                  )}>
                    <Route index path='/settings/data-customization/*' element={<RestrictedView type='restricted' userPermission={USER_PERMISSIONS.DATA_CUSTOMIZATION_VIEW}><DataCustomizationParentGroup /></RestrictedView>} />
                  </Route>
                  <Route path='library' element={(
                    <SettingsPage
                      title={'Library'}
                      details={{
                        favorite_type: "settings",
                        setting_report_type: "crm_customization.library"
                      }}
                      breadcrumbs={(
                        <Breadcrumb>
                          <Breadcrumb.Section as={Link} to="/settings/general">Settings</Breadcrumb.Section>
                          <Breadcrumb.Divider />
                          <Breadcrumb.Section as={Link} to={`/settings/crm-customizations`}>CRM Customizations</Breadcrumb.Section>
                          <Breadcrumb.Divider />
                          <Breadcrumb.Section>Library</Breadcrumb.Section>
                        </Breadcrumb>
                      )}
                    >
                      <Page component={Library} title={'Library'} />
                    </SettingsPage>
                  )}>
                    {LIBRARY_ROUTES}
                  </Route>
                  <Route path='product-catalog-quotes-invoices' element={(
                    <SettingsPage
                      title={'Product Catalog'}
                      details={{
                        favorite_type: "settings",
                        setting_report_type: "crm_customization.product_catalog_quotes_invoices"
                      }}
                      breadcrumbs={(
                        <Breadcrumb>
                          <Breadcrumb.Section as={Link} to="/settings/general">Settings</Breadcrumb.Section>
                          <Breadcrumb.Divider />
                          <Breadcrumb.Section as={Link} to={`/settings/crm-customizations`}>CRM Customizations</Breadcrumb.Section>
                          <Breadcrumb.Divider />
                          <Breadcrumb.Section>Product Catalog</Breadcrumb.Section>
                        </Breadcrumb>
                      )}
                    >
                      <Page component={ProductManagement} title={'Product Catalog'} />
                    </SettingsPage>
                  )}
                  >
                    {PRODUCT_MANAGEMENT_ROUTES}
                  </Route>
                  <Route path='billing' element={(
                    <SettingsPage
                      title={'Billing'}
                      details={{
                        favorite_type: "settings",
                        setting_report_type: "account_management.billing"
                      }}
                      breadcrumbs={(
                        <Breadcrumb>
                          <Breadcrumb.Section disabled={hasOutstandingInvoices} as={hasOutstandingInvoices ? ButtonLink : Link} to="/settings/general">Settings</Breadcrumb.Section>
                          <Breadcrumb.Divider />
                          <Breadcrumb.Section disabled={hasOutstandingInvoices} as={hasOutstandingInvoices ? ButtonLink : Link} to={`/settings/account-management`}>Account Management</Breadcrumb.Section>
                          <Breadcrumb.Divider />
                          <Breadcrumb.Section>Billing</Breadcrumb.Section>
                        </Breadcrumb>
                      )}
                    >
                      <Page component={Billing} title={'Billing'} />
                    </SettingsPage>
                  )}
                  >
                    {BILLING_ROUTES}
                  </Route>
                  <Route path='usage-stats' element={(
                    <SettingsPage
                      title={'Usage Stats'}
                      details={{
                        favorite_type: "settings",
                        setting_report_type: "account_management.usage_stats"
                      }}
                      breadcrumbs={(
                        <Breadcrumb>
                          <Breadcrumb.Section disabled={hasOutstandingInvoices} as={hasOutstandingInvoices ? ButtonLink : Link} to="/settings/general">Settings</Breadcrumb.Section>
                          <Breadcrumb.Divider />
                          <Breadcrumb.Section disabled={hasOutstandingInvoices} as={hasOutstandingInvoices ? ButtonLink : Link} to={`/settings/account-management`}>Account Management</Breadcrumb.Section>
                          <Breadcrumb.Divider />
                          <Breadcrumb.Section>Usage Stats</Breadcrumb.Section>
                        </Breadcrumb>
                      )}
                    >
                      <Page component={UsageStats} title={'Usage Stats'} />
                    </SettingsPage>
                  )}
                  >
                    {USAGE_STATS_ROUTES}
                  </Route>
                  <Route path='pipelines' element={(
                    <SettingsPage
                      title={'Pipeline'}
                      details={{
                        favorite_type: "settings",
                        setting_report_type: "crm_customization.pipeline"
                      }}
                      breadcrumbs={(
                        <Breadcrumb>
                          <Breadcrumb.Section as={Link} to="/settings/general">Settings</Breadcrumb.Section>
                          <Breadcrumb.Divider />
                          <Breadcrumb.Section as={Link} to={`/settings/crm-customizations`}>CRM Customizations</Breadcrumb.Section>
                          <Breadcrumb.Divider />
                          <Breadcrumb.Section>Pipeline</Breadcrumb.Section>
                        </Breadcrumb>
                      )}
                    >
                      <Page component={Pipelines} title={'Pipeline'} />
                    </SettingsPage>
                  )}>
                    {PIPELINE_ROUTES}
                  </Route>
                  <Route path='assignment-rules' element={(
                    <SettingsPage
                      title={'Assignment Rules'}
                      breadcrumbs={(
                        <Breadcrumb>
                          <Breadcrumb.Section as={Link} to="/settings/general">Settings</Breadcrumb.Section>
                          <Breadcrumb.Divider />
                          <Breadcrumb.Section as={Link} to={`/settings/automation`}>Automation</Breadcrumb.Section>
                          <Breadcrumb.Divider />
                          <Breadcrumb.Section>Assignment Rules</Breadcrumb.Section>
                        </Breadcrumb>
                      )}
                    >
                      <Page component={AssignmentRulesContainer} title={'Assignment Rules'} />
                    </SettingsPage>
                  )}>
                    {ASSIGNMENT_RULES_ROUTES}
                  </Route>
                  <Route path='*' element={<Error404 />} />
                </Route>
              </Route>
            </Routes>
          </Router>
      </MainSidePanelProvider>

      {/* Removed until we can establish why the client-side de-authenticates a user <IdleCheck /> */}
      <div class="App__audioHolder" style={{ display: "none" }}>
        <audio class="App__ringTone" src="https://images.dyl.com/dyl2/incoming.mp3" loop></audio>
        <audio class="App__ringbackTone" src="https://images.dyl.com/dyl2/outgoing.mp3" loop></audio>
        <audio class="App__dtmfTone" src="https://images.dyl.com/dyl2/dtmf.mp3"></audio>
        <audio class="App__callWait" src="https://images.dyl.com/dyl2/callwait.mp3"></audio>
        <audio class="App__audioRemote"></audio>
      </div>
    </div>
  );
}

const SettingsComponent = ({ main_path, name, header, pathId, Component, favorite_type, type, subroute }) => {
  const location = useLocation();
  const params = useParams();
  const breadcrumbRoute = pathId ? `${main_path}/${params?.id}` : main_path;
  return (
    <SettingsPage
      {...type ? ({
        details: {
          favorite_type: favorite_type || "settings",
          setting_report_type: type
        }
      }) : {}}
      breadcrumbs={(
        <Breadcrumb>
          <Breadcrumb.Section as={Link} to="/settings/general">Settings</Breadcrumb.Section>
          <Breadcrumb.Divider />
          <Breadcrumb.Section as={Link} to={`/settings/${breadcrumbRoute}`}>{name}</Breadcrumb.Section>
          <Breadcrumb.Divider />
          {subroute && (
            <>
              <Breadcrumb.Section as={Link} to={`/settings/${subroute.path}`}>{subroute.name}</Breadcrumb.Section>
              <Breadcrumb.Divider />
            </>
          )}
          <Breadcrumb.Section>{location.state?.breadcrumb_header || header}</Breadcrumb.Section>
        </Breadcrumb>
      )}
      title={header}
    >
      <Component />
    </SettingsPage>
  );
}

export default App;



